const tabs = (() => {
  const initBlock = el => {
    handleTabsSwitching(el);
  };
  const handleTabsSwitching = el => {
    el.querySelectorAll('[data-tab]').forEach(tab => {
      tab.addEventListener('click', () => {
        resetTabs(el);
        const content = el.querySelector('.tabs__content__wrapper[data-id="' + tab.dataset.id + '"]');
        tab.classList.add('tabs__tabs__tab--active');
        content.classList.add('tabs__content__wrapper--active');
      })
    });
  };
  const resetTabs = el => {
    el.querySelectorAll('[data-tab]').forEach(tab => {
      tab.classList.remove('tabs__tabs__tab--active');
    });
    el.querySelectorAll('.tabs__content__wrapper').forEach(content => {
      content.classList.remove('tabs__content__wrapper--active');
    });
  };
  return {initBlock};
})();
ControlBinders.register(`.tabs`, el => tabs.initBlock(el));